export default __webpack_public_path__ + "static/media/step4viewrecipes.cec16357.png";